export const getters = {
  parkingItems: state => state.parking_items,
  systemParkings: state => state.parkings
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/parkings/getters.js